var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 319,
    viewBox: "0 0 1920 319",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1919.61 1H0V317.648H1919.61V1Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M756.124 1.40477L72.7853 328.854H3.64062L752.07 0.643555L756.124 1.40477ZM1181.8 1.40477L1865.16 328.854H1934.26L1185.85 0.643555L1181.8 1.40477Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1076 1.5L1437.5 318.5",
    stroke: "#AAFECC",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1292 1L1919.5 185",
    stroke: "#AAFECC",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1399 1L1919.5 115.5",
    stroke: "#AAFECC",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1507 1L1919 74",
    stroke: "#AAFECC",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1615 1L1919.5 46",
    stroke: "#AAFECC",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1723 1L1920 26",
    stroke: "#AAFECC",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M860 1.5L498.5 318.5",
    stroke: "#AAFECC",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M644 1L0 190",
    stroke: "#AAFECD",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M537 1L-0.5 119",
    stroke: "#AAFECD",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M429 1L-0.5 77",
    stroke: "#AAFECD",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M321 1L-0.5 48.5",
    stroke: "#AAFECD",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M213 1L-1 28.5",
    stroke: "#AAFECD",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 959.794,
    y1: -69.4646,
    x2: 959.794,
    y2: 314.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CFA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#01A18F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#037878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#045564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#053954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#052348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#06133F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#060A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 893745,
    y1: 109121,
    x2: 893745,
    y2: 159091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAFECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#84FECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#4CFECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#23FECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#09FECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#00FECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008391"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 152818,
    y1: 52093.1,
    x2: 152818,
    y2: 59975.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1272D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#651418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#1C0607"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRode);
export default __webpack_public_path__ + "static/media/rode.d31d8426e14cc1b6f5702e44b140acb3.svg";
export { ForwardRef as ReactComponent };